/**
 * Shared class names for the dynamic form fields. The rules live in
 * styles/components/forms.css (theme-aware via the PABO --pg-* / --pabo-* tokens).
 */
export const FIELD_CLASS = 'form-input';

export const LABEL_CLASS = 'form-label';

export const CHOICE_CONTROL_CLASS = 'form-choice-control';
